(function($) {
	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#form-purchase-step-1',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/premium-membership/purchase/review-your-purchase',
			SESSION_EXPIRED: '/premium-membership/purchase/session-expired',
			ERROR: function() {
				lDialog.close();
			}
		}
	});

})(jQuery);

jQuery(function initHandlePurchaseStep1Form($) {
	$('.form-purchase-step-1').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('.form-purchase-step-1');
		var $submitBtn             = $container.find('.btn-submit');

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('.form-purchase-step-1')[0].checkValidity(); // returns true/false

			if (checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
			}
		});

		// Membership Price Actions Below
		$(function(){
			$('input[name="membership-id"]:radio').change(function() {
				ajaxApplyMembershipPrice('price');
			});
		});

		$(function(){
			$('#state-province-b').on('change', function() {
				ajaxApplyMembershipPrice('state');
			});
		});

		function ajaxApplyMembershipPrice($status) {
			membershipID = $('input[name=membership-id]:checked', '.form-purchase-step-1').val();
			stateProvince =  $('#state-province-b').val();

			if (membershipID !== '' && stateProvince !== '') {
				$.ajax({
					method: "POST",
					url: "/h/premium/ApplyMembershipPrice",
					dataType: 'JSON',
					data: { membershipID: membershipID, stateProvince: stateProvince },
				})
				.done(function( data ) {
					// Success - Process
					$('.js-membership-exp-date').html(data.membershipExpDate);
					$('.js-membership-price').html(data.originalPrice);
					$('.js-subtotal-price').html(data.membershipPrice);
					$('.js-tax-cost').html(data.taxCost);
					$('.js-final-price').html(data.finalPrice);

					if (data.displayDiscount === 'true') {
						$('.js-discount-amount').html('-' + data.priceDiscount);
						$('.js-price-discount').show();
					} else {
						$('.js-discount-amount').html('0.00');
						$('.js-price-discount').hide();
					}
					
					if ($status === 'state') {
						launchInfoDialog("Your 'Billing State' has been updated and the Trip Summary has been updated to reflect the new Taxes.");
					}
					else {
						var $upgradeText = $('input[name="membership-id"]:checked').parent().text();
						//launchInfoDialog("The Premium " + $upgradeText + " has been applied.");
					}
				})
				.fail(function() {
					alert( "An unexpected error has occurred." );
				});
			}
			else {
				launchInfoDialog("To calculate your Premium Membership Upgrade cost, your Billing State / Province is required.");

				// Set the radio membership to the default / 1st value
				$("input[name=membership-id][value='3']").prop('checked', true);
			}
		}
	});
});


jQuery(function initHandlePurchaseStep2Form($) {
	$('#form-purchase-step-2').each(function(index, el) {

		var $container = $(this);
		var $submitBtn = $container.find('.btn-submit');

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('#form-purchase-step-2')[0].checkValidity(); // returns true/false
		
			if (checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
				
				setTimeout(function(){
					$("#form-purchase-step-2").submit();
				},1000);
			}
		});
	});
});

